import { ReactNode } from 'react';
import { NavigationStepperWrapper } from '@/components/NavigationStepper/styles';
import { NavigationStepperStep } from '@/components/NavigationStepper/ui/NavigationStepperStep';

export type NavigationStepType = {
  title: ReactNode;
  isCompleted: boolean;
  isActive: boolean;
};

type NavigationStepperType = {
  steps: NavigationStepType[];
};

export const NavigationStepper = ({ steps }: NavigationStepperType) => {
  return (
    <NavigationStepperWrapper>
      {steps.map((step, index) => {
        return (
          <NavigationStepperStep key={index} isCompleted={step.isCompleted} isActive={step.isActive}>
            {step.title}
          </NavigationStepperStep>
        );
      })}
    </NavigationStepperWrapper>
  );
};
